"use client";

import { Header } from "@/components/shared/public/blogs";
import {
  AdditionalInfo,
  PriceCalculation,
  ServiceDescription,
  ServiceObjects,
} from "@/views/public/three-sixty-service";
import { useTranslations } from "next-intl";
import { header } from "../../../../../public/images/blogs/ThreeSixtyDegreeMatterportService";

export default function MatterportServiceContent() {
  const t = useTranslations("blogs.ThreeSixtyDegreeMatterportService");
  return (
    <>
      <Header
        title={t("header.title")}
        text={t("header.text")}
        src={header}
        alt={t("header.imageAlt")}
        width={1200 * 0.4}
        height={976 * 0.4}
      />
      <ServiceDescription />
      <ServiceObjects />
      <AdditionalInfo />
      <PriceCalculation />
    </>
  );
}
